export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.16-1550.07",
  commitId: "becb7ad1fd1ad384eaa4cdf9cc7f959c55ec52de",
  commitTime: "2026-04-16T15:50:07.000Z",
});
